import React from 'react';
import { useTranslation } from 'react-i18next';
import PassengerCodeOfConductText from '../components/PassengerCodeOfConductText';
import './FlightSafetyPage.css';

const EasaCharterPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flight-safety-page">
      <div className="flight-safety-header">
        <h1>{t('easaCharter.title')}</h1>
        <p>{t('easaCharter.lead')}</p>
      </div>
      <div className="container">
        <div className="flight-safety-content">
          <section>
            <h2>{t('easaCharter.charterHeading')}</h2>
            <p>{t('easaCharter.charterIntro')}</p>
          </section>
          <section>
            <h2>{t('easaCharter.articlesHeading')}</h2>
            <ol>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                <li key={n}>{t(`easaCharter.a${n}`)}</li>
              ))}
            </ol>
          </section>
          <section>
            <h2>{t('easaCharter.annexPaxWarnTitle')}</h2>
            <blockquote>{t('easaCharter.annexPaxWarnBody')}</blockquote>
          </section>
          <section>
            <h2>{t('easaCharter.pilotCodeTitle')}</h2>
            <ol>
              {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <li key={n}>{t(`easaCharter.pc${n}`)}</li>
              ))}
            </ol>
          </section>
          <section>
            <PassengerCodeOfConductText />
          </section>
          <section>
            <h2>{t('easaCharter.checklistTitle')}</h2>
            <ul>
              {[1, 2, 3, 4, 5].map((n) => (
                <li key={n}>{t(`easaCharter.ck${n}`)}</li>
              ))}
            </ul>
          </section>
          <section>
            <h2>{t('easaCharter.dataTitle')}</h2>
            <ul>
              {[1, 2, 3, 4, 5].map((n) => (
                <li key={n}>{t(`easaCharter.d${n}`)}</li>
              ))}
            </ul>
          </section>
          <section>
            <p>{t('easaCharter.footerSource')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default EasaCharterPage;
